import './App.scss';
import {useState, useEffect} from "react";
import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom';

import PopupContext from "./components/Popup/PopupContext";
import AccountsOverview from "./pages/Accounts/AccountsOverview";
import {callAPI, setCustomerType} from "./utils/utils";

//const basename = "/customer.bak";
const basename = "/customer";
const baseUrl = "https://de.page4.com" + basename;

const App = () => {
  const [initialized, setInitialized] = useState(false);
  const [popupContent, setPopupContent] = useState(false);

  useEffect(() => {
    callAPI("customer", "GET", "", {}).then((data) => {
      setCustomerType(data.customer.type);
      setInitialized(true);
    });
  }, []);

  return (
    <PopupContext.Provider value={{popupContent, setPopupContent}} >
      {initialized &&
        <Router basename={basename}>
          <Switch>
            <Route path='/customer' component={() => {
              window.location.href = baseUrl + "/customer/";
              return null;
            }}/>
            <Route path='/profile' component={() => {
              window.location.href = baseUrl + "/profile/";
              return null;
            }}/>
            <Route path='/invoice' component={() => {
              window.location.href = baseUrl + "/invoice/";
              return null;
            }}/>
            <Route path='/account' component={AccountsOverview}/>
            <Route path='/domain' component={() => {
              window.location.href = baseUrl + "/domain/";
              return null;
            }}/>
            <Route path='/email' component={() => {
              window.location.href = baseUrl + "/email/";
              return null;
            }}/>
            <Route path='/logout' component={() => {
              window.location.href = baseUrl + "/logout/";
              return null;
            }}/>
            <Redirect to={'/account/'}/>
          </Switch>
        </Router>
      }
      {popupContent && <>{popupContent}</>}
    </PopupContext.Provider>
  );
};

export default App;
